<template>
  <a-row :gutter="16">
    <a-col v-for="(item,idx) in dataList" :key="idx" :span="4" @click="openDetail(item)">
      <a-card :body-style="{padding:'20px'}" style="border-radius: 8px" size="small">
        <template slot="title">{{ item.lable }}</template>
        <div
          style="height:110px;
        font-weight:500;
        text-align:center;
        font-size:60px;color:#201d1d"
        >
          {{ item.value }}
        </div>
      </a-card>
    </a-col>
    <BusinessRequirementListModal ref="businessRequirementListModalRef" />
  </a-row>
</template>

<script>
import BusinessRequirementListModal from '@/pages/business/requirement/components/BusinessRequirementListModal';

export default {
  components: { BusinessRequirementListModal },
  props: {
    datas: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      tableData: [],
      dataList: [
        { lable: '涉及追溯的需求数', value: 0 },
        { lable: '应用追溯数', value: 0 },
        { lable: '价值追溯数', value: 0 },
        { lable: '待完成追溯需求数', value: 0 }
      ]
    };
  },
  watch: {
    datas: {
      handler(data) {
        this.tableData = data || [];
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
  },
  methods: {
    openDetail(item) {
      if (item.lable === '追溯总数') {
        this.$refs.businessRequirementListModalRef.open(item.lable);
      } else if (item.lable === '追溯问答中') {
        this.$refs.businessRequirementListModalRef.open(item.lable, { statusList: [134] });
      } else if (item.lable === '进入生产追溯') {
        this.$refs.businessRequirementListModalRef.open(item.lable, { statusList: [135, 136, 137] });
      } else if (item.lable === '已交付') {
        this.$refs.businessRequirementListModalRef.open(item.lable, { statusList: [139] });
      }
    },
    setData(data) {
      this.tableData = data || [];
      this.changeData();
    },
    changeData() {
      const list = ['暂未追溯', '逾期未追溯'];
      this.dataList = [
        { lable: '涉及追溯的需求数', value: this.tableData.length },
        { lable: '应用追溯数', value: this.tableData.length },
        { lable: '价值追溯数', value: this.tableData.filter(item => item.retrospectType.includes(2)).length },
        { lable: '待完成追溯需求数', value: this.tableData.filter(it => list.includes(it.retrospectValueName)).length }
      ];
    }
  }
};
</script>

<style lang="less" scoped>

</style>
